// Cloudflare R2 configuration with custom domain
const R2_BASE_URL = 'https://assets.penguinsfrompluto.com';

// Map of animation names to their R2 URLs
const animationUrls = {
  'aside': `${R2_BASE_URL}/aside.json`,
  'csaba': `${R2_BASE_URL}/csaba.json`,
  'findAI': `${R2_BASE_URL}/findAI.json`,
  'hey-mom': `${R2_BASE_URL}/hey-mom.json`,
  'promptimizer': `${R2_BASE_URL}/promptimizer.json`,
  'sos': `${R2_BASE_URL}/sos.json`,
  'stalk-market': `${R2_BASE_URL}/stalk-market.json`
};

// Log the configuration to verify this version is loaded
console.log('R2 Configuration loaded - FIXED VERSION (May 5, 2025):', animationUrls);

// Utility function to fetch animation data
export const fetchAnimationData = async (animationName) => {
  try {
    const url = animationUrls[animationName];
    console.log(`[R2] Fetching animation: ${animationName} from URL: ${url}`);
    
    if (!url) {
      const error = new Error(`No URL found for animation: ${animationName}`);
      error.type = 'CONFIG_ERROR';
      throw error;
    }
    
    const response = await fetch(url);
    console.log(`[R2] Response status for ${animationName}:`, {
      status: response.status,
      statusText: response.statusText,
      url: response.url,
      headers: Object.fromEntries(response.headers.entries())
    });
    
    if (!response.ok) {
      const error = new Error(`Failed to fetch animation: ${response.status} ${response.statusText}`);
      error.type = 'NETWORK_ERROR';
      error.status = response.status;
      error.statusText = response.statusText;
      const text = await response.text();
      console.error(`[R2] Error response body:`, text);
      throw error;
    }
    
    const data = await response.json();
    console.log(`[R2] Successfully loaded animation: ${animationName}`);
    return data;
  } catch (error) {
    console.error(`[R2] Error loading animation ${animationName}:`, {
      name: error.name,
      message: error.message,
      type: error.type,
      status: error.status,
      stack: error.stack
    });
    throw error; // Re-throw to let the component handle it
  }
};

export default animationUrls;
